import { VueRenderer } from "@tiptap/vue-3";
import tippy from "tippy.js";

import MentionList from "./MentionList.vue";

export const mentionSuggestion = {
    items: async ({ query }) => {
        if (query.length < 2) {
            return [];
        }
        const teamIdFromUrl = new URLSearchParams(window.location.search).get(
            "teamId"
        );
        const response = await axios.get("/new-forum/utils/mentions", {
            params: {
                query: query,
                teamId: teamIdFromUrl,
            },
        });
        return response.data;
    },

    render: () => {
        let component;
        let popup;

        return {
            onStart: (props) => {
                component = new VueRenderer(MentionList, {
                    // using vue 2:
                    // parent: this,
                    // propsData: props,
                    // using vue 3:
                    props,
                    editor: props.editor,
                });

                if (!props.clientRect) {
                    return;
                }

                popup = tippy("body", {
                    getReferenceClientRect: props.clientRect,
                    appendTo: () => document.body,
                    content: component.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: "manual",
                    placement: "bottom-start",
                });
            },

            onUpdate(props) {
                component.updateProps(props);

                if (!props.clientRect) {
                    return;
                }

                popup[0].setProps({
                    getReferenceClientRect: props.clientRect,
                });
            },

            onKeyDown(props) {
                if (props.event.key === "Escape") {
                    popup[0].hide();

                    return true;
                }

                return component.ref?.onKeyDown(props);
            },

            onExit() {
                popup[0].destroy();
                component.destroy();
            },
        };
    },
};
